import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import * as Rx from 'rxjs'
import { Live } from '../../../lib/entity/live'
import { SubscribingHistory } from '../../../lib/entity/magazine'
import { LiveUserAuthority } from '../../../lib/entity/live-user-authority'
import { MagliveApiClient } from '../../../lib/api-client/maglive-api-client'
import { Magazine } from '../../../lib/entity/magazine'
import { environment } from '../../../env/environment'
import {
  FirestoreAccess,
  ARCHIVE_PAGE_SIZE,
} from '../../../lib/firestore-access'
import { switchMap, filter } from 'rxjs/operators'

@Component({
  templateUrl: './magazine-page.component.html',
  styleUrls: ['./magazine-page.component.scss'],
})
export class MagazinePageComponent {
  magazine$: Rx.Observable<Magazine | string> = Rx.of('NOT_INITIALIZED')
  baseURL = environment.baseURL

  authority: LiveUserAuthority | 'NOT_LOGIN'
  histories: SubscribingHistory[] = []
  broadcastingLives: Live[]
  reservedLives: Live[]
  archivedLives: Live[]
  following: Boolean
  followModalOpened: Boolean = false
  selectedMonth?: string
  archivedLivesOrder?: string
  magazineId: number
  magazineIdView: string
  userId: number
  allRead: Boolean
  // メンテナンスページ用
  isMaintenance: Boolean = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private firestoreAccess: FirestoreAccess
  ) {
    Rx.combineLatest([MagliveApiClient.getAuthority(), this.route.params])
      .pipe(
        switchMap(([authorities, params]) => {
          if (authorities.status === 503) {
            this.isMaintenance = true
          }
          const magazineId = (this.magazineId = parseInt(params.magazineId, 10))
          console.log(authorities, params)
          this.magazineIdView = params.magazineId
          if (isNaN(magazineId) || magazineId <= 0) {
            return Rx.of('NOT_FOUND' as 'NOT_FOUND')
          }
          const userId = authorities === 'NOT_LOGIN' ? null : authorities.userId
          this.userId = userId
          if (userId) {
            firestoreAccess
              .follows(userId, magazineId)
              .subscribe(
                (follows) =>
                  (this.following = follows.every((x) => x.following))
              )
            MagliveApiClient.getSubscribingHistories(magazineId)
              .pipe(filter((x) => x !== 'NOT_AUTHORIZED' && x !== 'NOT_LOGIN'))
              .subscribe((x) => (this.histories = x as SubscribingHistory[]))
          }
          return Rx.combineLatest([
            Rx.of(authorities),
            Rx.of(magazineId),
            firestoreAccess.archivedLives(userId, magazineId),
            firestoreAccess.broadcastingLives(userId, magazineId),
            firestoreAccess.reservedLives(userId, magazineId),
          ])
        })
      )
      .subscribe((value) => {
        if (value === 'NOT_FOUND') {
          this.magazine$ = Rx.of('NOT_FOUND')
          return
        }
        const [
          authorities,
          magazineId,
          archivedLives,
          broadcastingLives,
          reservedLives,
        ] = value
        this.authority = authorities
        this.magazine$ = MagliveApiClient.getMagazine(magazineId)
        if (this.archivedLives === undefined) {
          this.archivedLives = archivedLives
        }
        if (this.broadcastingLives === undefined) {
          this.broadcastingLives = broadcastingLives
        }
        if (this.reservedLives === undefined) {
          this.reservedLives = reservedLives
        }
      })
  }

  onFollowClick(following) {
    if (this.authority !== 'NOT_LOGIN') {
      const apiCall = following
        ? MagliveApiClient.followMagazine
        : MagliveApiClient.unfollowMagazine
      apiCall(this.magazineId.toString(), 'web').subscribe((_) => {
        this.following = following
      })
    }
    if (following) {
      this.toggleFollowModal()
    }
    return false
  }

  toggleFollowModal() {
    this.followModalOpened = !this.followModalOpened
  }

  get monthOptions(): string[] {
    const today = new Date()
    const startYear = 2019
    const currentYear = today.getFullYear()
    const years = [...new Array(currentYear - startYear + 1)].map(
      (_, i) => currentYear - i
    )
    return years.reduce((dates, year) => {
      const lastMonth = year === currentYear ? today.getMonth() + 1 : 12
      const startMonth = year === startYear ? 10 : 0
      const months = Array.from(new Array(lastMonth - startMonth).keys())
        .map((i) => i + startMonth + 1)
        .sort((a, b) => b - a)
      return dates.concat(months.map((m) => `${year}年${m}月`))
    }, [] as string[])
  }

  get shareURL(): string {
    return encodeURIComponent(location.href)
  }

  get shareText(): string {
    return encodeURIComponent(' まぐまぐ！Liveチャンネルで配信中')
  }

  get shareTags(): string {
    return encodeURIComponent('まぐまぐLive')
  }

  fetchLives(last?: Live) {
    let start = null
    let end = null
    if (this.selectedMonth) {
      const [year, month] = this.selectedMonth
        .replace('月', '')
        .split('年')
        .map((x) => parseInt(x, 10))
      start = new Date(year, month - 1)
      end = new Date(year, month)
    }
    Rx.from(
      this.firestoreAccess.archivedLives(
        this.userId,
        this.magazineId,
        this.archivedLivesOrder,
        start,
        end,
        last
      )
    ).subscribe((lives) => {
      if (last) {
        if (lives.length > 0) {
          this.archivedLives = this.archivedLives.concat(lives)
        } else {
          this.allRead = true
        }
      } else {
        this.archivedLives = lives
        if (lives.length < ARCHIVE_PAGE_SIZE) {
          this.allRead = true
        } else {
          this.allRead = false
        }
      }
    })
  }

  onSelect() {
    this.fetchLives()
  }

  onScroll() {
    if (this.allRead) return
    this.fetchLives(this.archivedLives[this.archivedLives.length - 1])
  }
}
